export function getFavorites (state) {
  return state.favorites
}
